import Awesomplete from 'awesomplete'

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('input[data-autocomplete-url], textarea[data-autocomplete-url]').forEach(function (input) {
    let autoComplete = null
    let timer

    if (input.hasAttribute('data-multiple')) {
      let options = {
        filter: function (text, input) {
          return Awesomplete.FILTER_CONTAINS(text, input.match(/[^,]*$/)[0])
        },
        item: function (text, input) {
          return Awesomplete.ITEM(text, input.match(/[^,]*$/)[0])
        },
        replace: function (text) {
          const before = this.input.value.match(/^.+,\s*|/)[0]
          this.input.value = before + text + ', '
        }
      }

    if (input.hasAttribute('data-basic')) {
      const quitaAcentos = function (text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      }

      options.sort = false

      // Deberia bastar con devolver true, pero peta spec/features/titulares_admin_spec.rb:23
      // aunque no consiga reproducirlo fuera del test
      options.filter = function (text, input) {
        text = quitaAcentos(text)
        input = quitaAcentos(input)

        return Awesomplete.FILTER_CONTAINS(text, input.match(/[^,]*$/)[0])
      }

      options.item = function (text, input) {
        return Awesomplete.ITEM(text, '')
      }
    }

    autoComplete = new Awesomplete(input, options)
  } else {
    autoComplete = new Awesomplete(input)
  }

    input.addEventListener('input', function () {
      const values = this.value.split(',')
      const lastValue = values[values.length - 1].trim()
      const url = this.getAttribute('data-autocomplete-url')
      const delay = isNaN(parseInt(input.dataset.delay)) ? 1 : parseInt(input.dataset.delay)

      if (lastValue.length >= autoComplete.minChars) {
        clearTimeout(timer)

        timer = setTimeout(function () {
          const urlObj = new URL(`${document.location.origin}${url}`)
          urlObj.searchParams.append('term', lastValue)
          fetch(`${urlObj.pathname}${urlObj.search}`, { credentials: 'same-origin' })
            .then(function (response) {
              return response.json()
            })
            .then(function (json) {
              input.dispatchEvent(new CustomEvent('awesomplete-response', { detail: { content: json } }))
              autoComplete.list = json
            })
        }, delay)
      }
    })
  })
})
